const CoffeeFlavorBody = [

  {
    "name": "Light"
  },
  {
    "name": "Medium"
  },
  {
    "name": "Heavy"
  },
  {
    "name": "Viscous"
  },
  {
    "name": "Oily"
  }
]
;

export default CoffeeFlavorBody;



// WEBPACK FOOTER //
// ./src/components/CoffeeFlavorBody.js